import { render, staticRenderFns } from "./UpdatePaymentDetails.vue?vue&type=template&id=2a1f7c4a&scoped=true&"
import script from "./UpdatePaymentDetails.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePaymentDetails.vue?vue&type=style&index=0&id=2a1f7c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f7c4a",
  null
  
)

export default component.exports